import App from './App.svelte';

const app = new App({
	target: document.body,
	props: {
		// steve: "stefano.gramolelli@idm-suedtirol.com",
		// manfred: "manfred.inama@idm-suedtirol.com"
	}
});

export default app;